import {styled} from "@mui/material/styles";
import {Chip} from "@mui/material";

export const FilterChip=styled(Chip)(({theme})=>({
    margin: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
        marginLeft: 0,
    },
}))